import { m } from 'framer-motion';
import { Box, Card, Container, Stack, styled, Typography } from '@mui/material';
import React, { useRef } from 'react';
import Slider from 'react-slick';
import { MotionViewport, varFade } from '../../components/animate';
import { CarouselArrows } from '../../components/carousel';

const PARTENAIRES_LIST = [
  {
    image: '/assets/partenaire/otr.jpg',
    url: 'https://otr.tg',
  },
  {
    image: '/assets/partenaire/dgdn.jpg',
    url: 'https://dgdn.gouv.tg',
  },

  {
    image: '/assets/partenaire/togo_invest.jpg',
    url: 'https://togoinvest.tg',
  },
  {
    image: '/assets/partenaire/port.jpg',
    url: 'https://www.togo-port.net',
  },
  {
    image: '/assets/partenaire/a2pl.png',
    url: 'https://a2pl.tg/',
  },

  {
    image: '/assets/partenaire/ccit.jpg',
    url: 'https://www.ccit.tg',
  },
  {
    image: '/assets/partenaire/cfe.jpg',
    url: 'https://www.cfetogo.tg',
  },

  {
    image: '/assets/partenaire/seguce.jpg',
    url: 'https://www.segucetogo.tg',
  },
  {
    image: '/assets/partenaire/asozof.jpg',
    url: 'https://asozof.org',
  },

  {
    image: '/assets/partenaire/pia.jpg',
    url: 'https://pia-togo.com',
  },
  {
    image: '/assets/partenaire/ceet.jpg',
    url: 'https://www.ceet.tg',
  },

  {
    image: '/assets/partenaire/cnss.jpg',
    url: 'https://cnss.tg',
  },
  {
    image: '/assets/partenaire/yas.png',
    url: 'https://www.yas.tg',
  },
  {
    image: '/assets/partenaire/tde.jpg',
    url: 'https://www.tde.tg',
  },
  {
    image: '/assets/partenaire/e_foncier.jpg',
    url: 'https://e-foncier.otr.tg/',
  },

  {
    image: '/assets/partenaire/usaid.jpg',
    url: 'https://www.usaid.gov/',
  },
  {
    image: '/assets/partenaire/onud.jpg',
    url: 'https://www.unido.org/',
  },

  {
    image: '/assets/partenaire/opic.jpg',
    url: 'https://www.opic.gov/',
  },
  {
    image: '/assets/partenaire/pnud.jpg',
    url: 'https://www.undp.org/fr/togo',
  },
];

const ContentStyle = styled(Stack)(() => ({
  backgroundImage: 'url(/assets/background/Nos_partenanires.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export default function HomePartenard() {
  const slider = useRef(null);

  const handlePrevious = () => {
    slider.current?.slickPrev();
  };

  const handleNext = () => {
    slider.current?.slickNext();
  };

  const settings2 = {
    dots: false,
    infinite: true,
    arrows: false,
    centerMode: false,
    swipeToSlide: true,
    focusOnSelect: true,
    variableWidth: false,
    centerPadding: '0px',
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  // Ouvre le site du partenaire dans un nouvel onglet
  const handleLogoClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <ContentStyle width={1} bgcolor="secondary.main">
      <Container component={MotionViewport} maxWidth="lg">
        <Stack width={1} alignItems="center" mt={10} mb={5}>
          <m.div variants={varFade().inUp}>
            <Typography textAlign="center" variant="h2">
              Ils contribuent à lʼécosystème dʼinvestissement au Togo
            </Typography>
          </m.div>
          <m.div variants={varFade().inUp}>
            <Stack width={1} alignItems="center">
              <Box height={8} width={150} bgcolor="#1E5649" />
            </Stack>
          </m.div>
        </Stack>
        <Stack position="relative" width={1} mb={{ xs: 2, md: 5 }} px={{ xs: 0, md: 4 }} pb={10}>
          <CarouselArrows color="#cb011c" filled onNext={handleNext} onPrevious={handlePrevious}>
            <Slider adaptiveHeight ref={slider} {...settings2}>
              {PARTENAIRES_LIST.map(({ image, url }) => (
                <Box key={url + image} px={{ xs: 1, md: 2 }} py={2}>
                  <Card
                    elevation={10}
                    onClick={() => handleLogoClick(url)}
                    sx={{
                      p: { xs: 1.5, md: 3 },
                      width: '100%',
                      minHeight: { xs: 70, md: 140 },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <Box
                      component="img"
                      src={image}
                      alt=" "
                      sx={{
                        width: '100%',
                        maxHeight: { xs: 50, md: 100 },
                        objectFit: 'contain',
                      }}
                    />
                  </Card>
                </Box>
              ))}
            </Slider>
          </CarouselArrows>
        </Stack>
      </Container>
    </ContentStyle>
  );
}
